<div style="min-height: calc(100vh - 126px);">
    <app-navbar></app-navbar>
    <router-outlet></router-outlet>
</div>